import { DivSearchMain, InputMain, LoopSearchMain, StyledMain, DivSearchMainAdvanced, DivSearchDropdown, MenuSearchMainAdvanced, DivSearchError, DivContainerSearchRow, DivApplyFilters, ButtonAddRow, SuggestionsList, SuggestionItem, DivOrSeparator } from './search.styled';
import { FilterRow } from './filterRow.js';
import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchingUserStart, fetchingUserReset } from '../../redux/user/userSlice';
import { fetchingGroupReset } from '../../redux/group/groupSlice.js';
import { fetchingApplicationReset } from '../../redux/application/applicationSlice.js';
import { fetchingDeviceReset } from '../../redux/device/deviceSlice.js';
import { fetchingDelegationReset } from '../../redux/delegation/delegationSlice.js'
import { fetchingOrganizationReset } from '../../redux/organization/organizationSlice.js'
import { fetchingAdvancedSearchReset, fetchingAdvancedSearchStart } from '../../redux/advancedSearch/advancedSearchSlice.js';
import { getCurrentSearchUsers } from '../../api/internal/usersInternalApi.js';

export default function Search({inputRef, inputPlaceHolder, page, needFilters, filterRow, setFilterRow, isActiveDiffSearch, setIsActiveDiffSearch, isActiveDiffSearchError, setActiveFilters}) {
    const [openMenuAdvanced, setOpenMenuAdvanced] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const searchDropdownRef = useRef();
    const suggestionsDropdownRef = useRef();
    const { isActive, isError, messageErrorSearch } = useSelector((state) => state.user);
    const { isAdvancedSearchActive, isAdvancedSearchError, messageErrorAdvancedSearch } = useSelector((state) => state.advancedSearch);
    const dispatch = useDispatch();
    
    const triggerSearch = () => {
        if (page === "Users" || page === "advancedSearch") {
            if (filterRow && needFilters || inputRef && !needFilters) {
                if (isActive === true && !needFilters) {
                    dispatch(fetchingUserReset());
                    dispatch(fetchingGroupReset());
                    dispatch(fetchingApplicationReset());
                    dispatch(fetchingDeviceReset());
                    dispatch(fetchingDelegationReset());
                    dispatch(fetchingOrganizationReset());
                    setTimeout(() => {
                        dispatch(fetchingUserStart());
                    }, 100);
                } else if (isAdvancedSearchActive === true && needFilters) {
                    dispatch(fetchingAdvancedSearchReset());
                    setActiveFilters([...filterRow]);
                    setTimeout(() => {
                        dispatch(fetchingAdvancedSearchStart());
                    }, 100);
                } else if (filterRow && needFilters) {
                    setActiveFilters([...filterRow]);
                     setTimeout(() => {
                        dispatch(fetchingAdvancedSearchStart());
                    }, 100);
                } else {
                    dispatch(fetchingUserStart());
                }
            }
        } else if (page === "Diff") {
            if (inputRef && !isActiveDiffSearch) {
                setIsActiveDiffSearch(true);
            } else {
                setIsActiveDiffSearch(false);
                setTimeout(() => {
                    setIsActiveDiffSearch(true);
                }, 100);
            }
        }
    };

    const handleClickIsActive = () => {
        triggerSearch();
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            triggerSearch();
        }
    };
    
    const handleInputChange = async (e) => {
        const value = e.target.value;
        
        if (value.length > 2) {
            try {
                const results = await getCurrentSearchUsers(value);
                setSuggestions(results);
                setShowSuggestions(true);
            } catch (error) {
                console.error("Erreur recherche suggestions", error);
            }
        } else {
            setShowSuggestions(false);
        }
    };

    const selectSuggestion = (userMail) => {
        if (inputRef.current) {
            inputRef.current.value = userMail;
        }
        setShowSuggestions(false);
        triggerSearch();
    };

    const addRow = () => {
        const lastRow = filterRow.length > 0 ? filterRow[filterRow.length - 1] : null;
        const newRow = { 
            id: filterRow.length + 1,
            operator: 'AND',
            comparator: 'contains',
            information: lastRow ? lastRow.information : 'Users',
            propertie: null,
            input: null,
            action: 'remove'
        };
        setFilterRow([...filterRow, newRow]);
    };

    if (needFilters) {
        useEffect(() => {
            const closeDropdown = (e) => {
                if (!searchDropdownRef.current.contains(e.target)) {
                    setOpenMenuAdvanced(false);
                }
            }
            
            document.addEventListener('click', closeDropdown);
            
            return () => document.removeEventListener('click', closeDropdown);
        }, []); 
    } else {
        useEffect(() => {
            const closeDropdown = (e) => {
                if (!suggestionsDropdownRef.current.contains(e.target)) {
                    setShowSuggestions(false);
                }
            }
            
            document.addEventListener('click', closeDropdown);
            
            return () => document.removeEventListener('click', closeDropdown);
        }, []); 
    }

    return (
        <>
            <StyledMain className="search-container">
                { needFilters ? (
                    <>
                        <DivSearchMainAdvanced ref={searchDropdownRef}>
                            {/* <DivLabelLine>{checkedValues.id}</DivLabelLine> */}
                            <span>Select your filters</span>
                            <MenuSearchMainAdvanced className="bx bx-menu" onClick={() => {setOpenMenuAdvanced(!openMenuAdvanced)}}/>
                            <DivSearchDropdown className={`${openMenuAdvanced ? 'active' : 'inactive'}`} onKeyDown={handleKeyDown}>
                                {
                                    filterRow.map((row, k) => (
                                        <React.Fragment key={k}>
                                            {k > 0 && row.operator === 'OR' && (
                                                <DivOrSeparator>
                                                    <span>OR - group separator</span>
                                                </DivOrSeparator>
                                            )}

                                            <DivContainerSearchRow>
                                                <FilterRow
                                                    filterRow={filterRow}
                                                    setFilterRow={setFilterRow}
                                                    buttonAction={row}
                                                />
                                            </DivContainerSearchRow>

                                        </React.Fragment>
                                    ))
                                }
                                <div style={{display: 'flex', justifyContent: 'end'}}>
                                    <ButtonAddRow onClick={() => addRow()}>+</ButtonAddRow>
                                </div>
                            </DivSearchDropdown>
                        </DivSearchMainAdvanced>
                        <DivApplyFilters onClick={handleClickIsActive}>
                            <span>Apply filters</span>
                        </DivApplyFilters>
                    </>
                ) : (
                    <DivSearchMain className={"search-main-div" + " " + (needFilters == false ? (isError ? "invalid-input" : "valid-input") : (isAdvancedSearchError ? "invalid-input" : "valid-input"))} ref={suggestionsDropdownRef}>
                        <InputMain className="search-input" placeholder={inputPlaceHolder} ref={inputRef} onKeyDown={handleKeyDown} onChange={handleInputChange} autoComplete='off'/>
                        <LoopSearchMain className="bx bx-search-alt-2" onClick={handleClickIsActive}/>
                        {showSuggestions && Array.isArray(suggestions) && suggestions.length > 0 && (
                            <SuggestionsList>
                                {suggestions.map((user, index) => (
                                    <SuggestionItem key={index} onClick={() => selectSuggestion(user.userPrincipalName)}>
                                        {user.displayName} ({user.userPrincipalName})
                                    </SuggestionItem>
                                ))}
                            </SuggestionsList>
                        )}
                    </DivSearchMain>
                )}
            </StyledMain>
            <DivSearchError>
                {isError && needFilters == false ? messageErrorSearch : null}
                {isAdvancedSearchError && needFilters ? messageErrorAdvancedSearch : null}
                {isActiveDiffSearchError ? isActiveDiffSearchError : null}
            </DivSearchError>
        </>
    )
}